<template>
    <DeleteModal
        :visible.sync="showModal"
        :is-loading="isLoading"
        :is-submiting="isSubmiting"
        :disabled="!id"
        description="Deseja realmente excluir este banner? Esta ação não poderá ser desfeita."
        @cancel="toggleModal"
        @confirm="onSubmit"
        @closed="resetModal"
    >
        <!-- <div v-if="reseller" class="d-flex align-items-center">
            <el-avatar size="small">{{ reseller.nome.charAt(0) }}</el-avatar>
            <span class="font-weight-bold ml-2">{{ reseller.nome }}</span>
        </div> -->
    </DeleteModal>
</template>
<script>
    // Components
    import {
        Notification,
        Avatar,
    } from "element-ui";

    import DeleteModal from "@/components/_micro/modals/DeleteModal.vue";

    // Api
    import { DistribuidorRevendedoraApi } from "@/api/DistribuidorRevendedoraApi";
    import { BannerApi } from "@/api/BannerApi";

    const bannerApi = new BannerApi();

    export default {
        data() {
            return {
                id: null,
                banner: null,
                showModal: false,
                isLoading: false,
                isSubmiting: false,
            }
        },
        methods: {
            async show() {
                try {
                    this.isLoading = true;

                    const res = await bannerApi.show(this.id);

                    this.banner = res;
                } catch (err) {
                    Notification.error({
                        title: 'Erro',
                        message: 'Não foi possível obter o banner! Algo inesperado Ocorreu.'
                    });
                } finally {
                    this.isLoading = false;
                }
            },
            async onSubmit() {
                if (!this.id) return;

                this.isSubmiting = true;

                try {
                    await bannerApi.destroy(this.id);

                    Notification.success({
                        title: 'Sucesso',
                        message: 'Banner excluído com sucesso!'
                    });

                    this.$emit('deleted');
                } catch (error) {
                    Notification.error({
                        title: 'Erro',
                        message: 'Não foi possível excluir o banner!'
                    });
                } finally {
                    this.isSubmiting = false;
                    this.toggleModal();
                }
            },
            /**Modal */
            toggleModal() {
                this.showModal = !this.showModal;
            },
            resetModal() {
                this.id = null;
                this.banner = null;
            },
        },
        components: {
            DeleteModal,
        },
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/_macro/banner/BannerDeleteModal.vue